var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"widget-item",style:(_vm.style),attrs:{"id":_vm.widget.object.wid}},[_c('TimeView',{staticClass:"time-app",attrs:{"app":_vm.widget.object},on:{"saveData":_vm.saveAppData}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }